import { $http } from '@/plugins/common/http';

export const login = (data) => {
    return $http.post('/users/login', data);
};
export const fetchUser = () => {
    return $http('/users/getUserInformation');
};

export const fetchRefreshToken = (refreshToken) => {
    return $http.post('/users/refresh', {
        refreshToken,
    });
};

export const fetchDefaultAddress = () => {
    return $http('/user/addresses?isDefault=1');
};

export const updateProfile = (data) => {
    return $http.put('/users', data);
};

export const updateCompanyInfo = (data) => {
    return $http.put('/users/company-info', data);
};

export const getPresignedSignature = (query) => {
    return $http.get('/users/signature/upload-file-url', {
        params: {
            ...query,
        },
    });
};
export const uploadFileSignature = (url, data) => {
    return $http.post(url, data, {
        transformRequest: (data, headers) => {
            delete headers.common['Authorization'];
            delete headers['Authorization'];
            headers.common['Content-Type'] = 'multipart/form-data';
            headers['Content-Type'] = 'multipart/form-data';
            return data;
        },
    });
};

export const enableTwoFA = () => {
    return $http.get('/2fa/turn-on');
};

export const verifyTwoFA = (code) => {
    return $http.post('/2fa/turn-on/verify', {
        code,
    });
};

export const disableTwoFA = (code) => {
    return $http.post('/2fa/turn-off', {
        code,
    });
};
